import { render } from "./StatusGruppen.pug?vue&type=template&id=3b7dd4b8&lang=pug"
import script from "./StatusGruppen.js?vue&type=script&lang=js"
export * from "./StatusGruppen.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__